import { useState } from "react";
import { CreateSecretPage } from "./CreateSecretPage";
import { loadReplyGrant } from "../lib/replyGrant";
import { useI18n } from "../i18n";
import { Card } from "../components/Card";

/**
 * The composer a recipient reaches from "Send one back". It exists as its
 * own route for one reason: `/` is behind `AuthGate` wherever SSO is on,
 * and the whole point of a reply grant is to serve someone who has no
 * account to sign in with. This route is deliberately outside that gate,
 * and its only key is the grant itself — no grant, nothing to compose.
 *
 * Read once, on mount: the grant is cleared as soon as the reply is sent,
 * and re-reading storage would swap the page out from under the result
 * screen that is showing someone their new link.
 */
export function ReplyPage() {
  const { m } = useI18n();
  const [reply] = useState(loadReplyGrant);

  if (!reply) {
    return (
      <Card narrow animate>
        <div className="heading-block">
          <h1>{m.reply.expired.title}</h1>
          <p>{m.reply.expired.body}</p>
        </div>
      </Card>
    );
  }

  return <CreateSecretPage reply={reply} />;
}
